<div (focusin)="pauseAutoClose()"
     (focusout)="resumeAutoClose()"
     (mouseenter)="pauseAutoClose()"
     (mouseleave)="resumeAutoClose()"
     [class.close]="!isVisible"
     [ngClass]="alertDialogOptions.feedbackState || 'none'"
     aria-labelledby="alertTitle"
     aria-modal="true"
     class="work-ui-alert-dialog work-dialog-overlay"
     role="dialog">
  <div class="work-ui-alert-dialog__content">
    @if (alertDialogOptions.feedbackState !== 'none') {
      <div class="work-ui-alert-dialog__state-icon">
        <work-ui-icon [name]="stateIconName">
        </work-ui-icon>
      </div>
    }
    <div>
      <div class="work-dialog-overlay__title">
        <div class="work-dialog-overlay__title-content">
          <p id="alertTitle"><b>{{ alertDialogOptions.title | translate }}</b></p>
          @if (alertDialogOptions.message) {
            <small [innerHTML]="alertDialogOptions.message | translate"></small>
          }
        </div>
        <work-ui-icon (click)="close()"
                      [name]="'close'"
                      class="close-button">
        </work-ui-icon>
      </div>
    </div>
  </div>

  @if (alertDialogOptions.actionLabel && alertDialogOptions.actionHandler) {
    <work-ui-button (click)="executeAction()"
                    [text]="alertDialogOptions.actionLabel">
    </work-ui-button>
  }
</div>
